import React from 'react';
import checkmarkIcon from '../assets/FerrySafe-Sublogo-vinkje.png';

export const FerryCheckmark = ({ className }) => (
  <img src={checkmarkIcon} alt="Ferry Safe checkmark" className={className} />
); 